module.exports = __webpack_public_path__ + "img/loreal.0cf3c067.png";